import { listViewStore } from 'owa-mail-list-store';
import { ActionSource } from 'owa-analytics-actions';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import pinConversations from './pinConversations';
import pinItems from './pinItems';

/**
 * Toggle the isPinned value of the rows
 * @param rowKeys to be pinned/unpinned
 * @param tableViewId the table view id
 * @param isPinnedToSet the isPinned value to be set
 * @param actionSource the action source
 */
export default function markRowsPinnedUnpinned(
    rowKeys: string[],
    tableViewId: string,
    isPinnedToSet: boolean,
    actionSource: ActionSource
) {
    const tableView = listViewStore.tableViews.get(tableViewId);

    switch (tableView.tableQuery.listViewType) {
        case ReactListViewType.Conversation:
            pinConversations(rowKeys, tableView, isPinnedToSet, actionSource);
            break;

        case ReactListViewType.Message:
            pinItems(rowKeys, tableView, isPinnedToSet, actionSource);
            break;
    }
}
